<div class="search-widget" [ngClass]="{'search-widget-hidden': (isActive === 'false' || isActive === '')}">
  <div class="search-widget__overlay" [ngStyle]="{'top': overlayTop}" (click)="closeWidget()" data-cy="search-overlay"></div>
  <div class="search-widget__wrapper" data-cy="search-wrapper">
    <div class="search-widget__bar">
      <input #searchBar id="search-bar" type="text" [formControl]="search" placeholder="Search..." data-cy="search-bar" />
      <button class="close" type="button" (click)="closeWidget()" data-cy="search-close"></button>
    </div>
    <div class="search-widget__results" [ngClass]="{'search-widget-hidden': !isResultsVisible, active: isRequestSent}">

      <lib-progress
        #search_widget_spinner
        [id]="'search_widget_spinner'"
        [loader]="false"
        [spinner]="true"
        [spinnerPosition]="'center'"
      ></lib-progress>

      <div class="search-widget__no-results" *ngIf="searchResults.length && 1 > searchResults.length">No results</div>
      <ul class="search-widget__results__list" *ngIf="searchResults.length && 0 < searchResults.length" data-cy="search-results-list">
        <li class="search-widget__results__list-item" *ngFor="let result of searchResults; index as i"
        [ngClass]="{'search-widget__results__list-item--selected': i === selectedSearchResultIndex && !hoverItemSelected}" data-cy="search-result-item">
          <a class="search-widget__results__link" href="javascript:void(0)" (mouseover)="hoverStatus(true, i)" 
          (mouseout) ="hoverStatus(false, i)"  (click)="selectChoice(result)" data-cy="search-result-link">
            {{ result.value }} in <span class="search-widget__results__result-category">{{ result.label }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
